import moment from 'moment';
import {
    SET_WIDGET_CLASS_DATA, 
    SET_WIDGET_INSTRUCTOR_DATA,
    INCREMENT_LOADING_COUNT,
    DECREMENT_LOADING_COUNT,
    SET_WIDGET_OFFERINGS,
    SET_WIDGET_ONDEMAND_DATA,
    SET_WIDGET_BOOKMARKS,
    ADD_WIDGET_BOOKMARK,
    DELETE_WIDGET_BOOKMARK
} from 'store/reducers/widgetReducer'
import {apiRequest} from 'util/api/util'
import { snapshotToObjects } from 'util/firestore';

export const sendMessage = (fromUserId, toUserId, message) => {

    return (dispatch, getState, { getFirebase, getFirestore }) => {

        // const firestore = getFirestore();
        // firestore.collection("messages")
        console.log("Send message")
    }

}

const MAX_RETRIES = 10

export const fetchInstructorData = (username, type, retryCount=0) => {

    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // make async call to DB
        // console.log("GETTING STUDIOS")
        // const firestore = getFirestore();
        if (retryCount > MAX_RETRIES) {
            return
        }
        dispatch({type: INCREMENT_LOADING_COUNT})
        console.log("fetching instructor data, ", username)

        type = type ?? "all"
        return apiRequest(`widget/data?widgetName=${username}&type=${type}`)
            .then(data => {
                let {widget, classes, offerings, offeringsMeta, onDemandProducts} = data

                if (widget) {
                    dispatch({ type: SET_WIDGET_INSTRUCTOR_DATA, instructor: widget })
                }

                if (classes) {
                    dispatch({ type: SET_WIDGET_CLASS_DATA, classes: classes })
                }

                if (offerings) {

                    if (offeringsMeta?.order) {
                        const order = offeringsMeta?.order ?? [];
                        for (let i = 0; i < offerings.length; i++) {
                            // look up position of this id in the ordering array and set the
                            // private _ordinal property if it exists
                            const oid = offerings[i].id;
                            const ii = order.indexOf(oid);
                            if (ii < 0) {
                                delete offerings[i]._ordinal;
                            } else {
                                offerings[i]._ordinal = ii;
                            }
                        }
                    }
                    dispatch({ type: SET_WIDGET_OFFERINGS, offerings: offerings})
                }

                if (onDemandProducts) {
                    dispatch({ type: SET_WIDGET_ONDEMAND_DATA, classes: onDemandProducts })
                }
                
                dispatch({type: DECREMENT_LOADING_COUNT})
                return widget.userID
            })
            .catch( err => {
                dispatch({type: DECREMENT_LOADING_COUNT})
                dispatch(fetchInstructorData(username, type, retryCount + 1))
                console.log("Error getting user: " + err);
            });
    }
};

export const fetchOndemand = (partnerId) => {

    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const firestore = getFirestore();
        let nowTimestamp = moment().unix();

        dispatch({type: INCREMENT_LOADING_COUNT})

        // Promise.all([
        //     firestore.collection("classes").where("instructor_id", "==", partnerId)
        //         .where("onDemand.downloadLink", ">", "")
        //         .where("onDemand.expires", ">", nowTimestamp)
        //         .get(),
        //     firestore.collection("classes").where("instructor_id", "==", partnerId)
        //         .where("onDemand.downloadLink", ">", "").get()
        // ])

        return firestore.collection("classes").where("partnerId", "==", partnerId).where("location_type", "in", ["ondemand", "product"]).where("deleted", "==", false).where("hidden", "==", false).where("expirationDate", ">", nowTimestamp).get()
            // return db.collection("users").doc(partnerId).collection(PRODUCTS_COLLECTION).where("deleted", "==", false).get()
                .then(snapshot => {
                    dispatch({type: DECREMENT_LOADING_COUNT})
                    const ondemandproducts = snapshotToObjects(snapshot)
                    console.log("Got products?")
                    console.log(ondemandproducts.length)
                    dispatch({ type: SET_WIDGET_ONDEMAND_DATA, classes: ondemandproducts })
                    // dispatch({type: SET_INSTRUCTOR_PRODUCTS, products: products})
                    return ondemandproducts
                })
    }
}

export const createBookmark = (classId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        return apiRequest(`bookmarks/createBookmark`, 'POST', {classId: classId})
            .then(bookmark => {
                dispatch({type: ADD_WIDGET_BOOKMARK, bookmark: bookmark})
                return bookmark
            })
    }
}

export const deleteBookmark = (classId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        return apiRequest(`bookmarks/deleteBookmark`, 'POST', {classId: classId})
            .then(bookmark => {
                dispatch({type: DELETE_WIDGET_BOOKMARK, bookmark: bookmark})
                return bookmark
            })
    }
}

export const getBookmarks = (partnerId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        return apiRequest(`bookmarks/getBookmarks?partnerId=${partnerId}`, 'POST')
            .then(bookmarks => {
                console.log('got bookmarks: ', bookmarks)
                dispatch({type: SET_WIDGET_BOOKMARKS, bookmarks: bookmarks})
                return bookmarks
            })
    }
}
